import { useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import { LocaleContext } from "../../../routing/LangRouter";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";
import useUserInfo from "../../../hooks/useUserInfo";
import { IS_MOBILE } from "../../../constants/breakpoints";
import BASE_URL from "../../../constants/baseUrls";
import { t } from "i18next";

//general component
import BaseTabs from "../../../components/common/base-tabs/base-tabs";
import BaseTitle from "../../../components/common/base-title/base-title";

//import view components
import WalletDashboard from "../../../components/view/user-panel/wallet/wallet-dashboard";
import DepositIncrement from "../../../components/view/user-panel/wallet/deposit-increment";
import DepositDecrement from "../../../components/view/user-panel/wallet/deposit-decrement";
import WalletTable from "../../../components/view/user-panel/wallet/wallet-table";
import CreditTable from "../../../components/view/user-panel/wallet/credit-table";

//styles
import "./wallet.scss";
import WalletCategory from "../../../components/view/user-panel/wallet/wallet-category";

function Wallet() {
    const accessToken = localStorage.getItem("accessToken");
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);

    //request to get user information
    const { userInformation, getUserInfo } = useUserInfo();

    //request get transe acction list
    const [transeActionList, setTranseActionList] = useState([]);

    const [creditRefundRequestList, setCreditRefundRequestList] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState(1);
    const onCategoryChange = value => {
        setSelectedCategory(value);
    };

    const getTranseAction = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/account/user/transactions/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            const list = response.data.results;

            setTranseActionList(list);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigate({
                    pathname: `/${locale}/authentication/signin`,
                    search: `?${createSearchParams({ prevLocation: location.pathname })}`,
                });
                toast.error(t("Toast Messages.Re-login"), { toastId: "custom-id-yes" });
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        }
    };

    const getCreditRefundRequest = async () => {
        try {
            const creditRefundRequestResponse = await axios.get(`${BASE_URL}/account/user/transactions/?type=11`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            const creditRefundRequestList = creditRefundRequestResponse.data.results;

            setCreditRefundRequestList(creditRefundRequestList);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigate({
                    pathname: `/${locale}/authentication/signin`,
                    search: `?${createSearchParams({ prevLocation: location.pathname })}`,
                });
                toast.error(t("Toast Messages.Re-login"), { toastId: "custom-id-yes" });
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        }
    };

    useEffect(() => {
        getUserInfo();
        getTranseAction();
        getCreditRefundRequest();
    }, []);

    // view transactions for mobile size
    const [viewTransactions, setViewTransactions] = useState(false);
    const handleViewTransactionsChange = value => {
        const close = value;
        setViewTransactions(close);
    };

    //handle tab change
    const [activeTab, setActiveTab] = useState({
        wallet: true,
        increment: false,
        decrement: false,
    });

    const handleTabChange = type => {
        setActiveTab({ [type]: true });
    };

    //list of tabs
    const tabList = [
        { type: "wallet", title: t("wallet"), activeTab: activeTab.wallet },
        {
            type: "increment",
            title: t("depositIncrement"),
            activeTab: activeTab.increment,
        },
        { type: "decrement", title: t("depositDecrement"), activeTab: activeTab.decrement },
    ];

    return (
        <Grid className="wallet" container item xs={12} rowGap={{ xs: 1, md: 2 }} mb={5}>
            {!IS_MOBILE && <BaseTitle title={`${t("wallet")}`} dividerColor="1px solid var(--medium-gray-color)" />}

            {IS_MOBILE && <BaseTabs handleTabChange={handleTabChange} list={tabList} style={{ top: "3rem" }} />}

            <Grid container item xs={12} rowGap={8} display={{ xs: "flex", sm: "none" }}>
                {activeTab.wallet && !viewTransactions ? (
                    <WalletDashboard userInformation={userInformation} handleViewTransactionsChange={handleViewTransactionsChange} />
                ) : activeTab.increment ? (
                    <DepositIncrement />
                ) : activeTab.decrement ? (
                    <DepositDecrement />
                ) : (
                    ""
                )}
            </Grid>

            <Grid container item xs={12} rowGap={8} display={{ xs: "none", sm: "flex" }}>
                <WalletDashboard userInformation={userInformation} />
            </Grid>

            {activeTab.wallet && (
                <Grid container item xs={12} rowGap={2} sx={{ padding: { sm: "25px 0" } }}>
                    {/* Use WalletCategory component instead of BaseTabs */}
                    <WalletCategory value={selectedCategory} setValue={onCategoryChange} />

                    <Grid container item xs={12}>
                        {/* Conditional rendering for table based on selectedCategory */}
                        {selectedCategory === 1 && <WalletTable transeActionList={transeActionList} />}
                        {selectedCategory === 2 && <CreditTable creditRefundRequestList={creditRefundRequestList} />}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}

export default Wallet;

